export default __webpack_public_path__ + "cdaaf97fdd5d3a70552068db1611bebb.svg";